import { t } from 'i18next';
import { OnboardingFormFields, USA_STATES_LIST } from '@Types/index';
import { ControlledDropdown } from '../ControlledInputs';
import type { ListItem } from '@lili/lili-frontend-common';

interface IProps {
  disabled?: boolean;
  tabIndex: number;
  statesList?: ListItem[] | undefined;
}
export const AddressStateInput = ({ disabled, tabIndex, statesList }: IProps) => {
  return (
    <ControlledDropdown
      title={t('pages.homeAddress.stateFieldTitle')}
      items={statesList ?? USA_STATES_LIST}
      id={OnboardingFormFields.STATE}
      disabled={disabled}
      tabIndex={tabIndex}
      name={OnboardingFormFields.STATE}
    />
  );
};
